import _ from "lodash";
import { assetsPath } from "../../utils";

const heroShotImg1 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/1_new.jpg`;
const heroShotImg2 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/7.jpg`;
const heroShotImg3 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/8.jpg`;
const heroShotImg4 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/2.jpg`;
const heroShotImg5 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/3.jpg`;
const heroShotImg6 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/4.jpg`;
const heroShotImg7 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/5.jpg`;
const heroShotImg8 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/hero-shot/6.jpg`;


const generateGallery = ({ imagePath = '', amount = 0, name = '', categoryId = 0 }) => {
  return _.map(_.range(amount), (value, index) => {
    const numberOrder = index + 1;
    let newName = (name !== '') ? `${name} - ${numberOrder}` : '';
    return {
      categoryId,
      name: newName,
      image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/${imagePath}/${numberOrder}.jpg`,
    };
  });
};

const residencesAerialData = [
  {
    categoryId: 2,
    name: "Aerial - 1",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-aerial/1.jpg`
  },
  {
    categoryId: 2,
    name: "Aerial - 2",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-aerial/2.jpg`
  },
  {
    categoryId: 2,
    name: "Aerial - 3",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-aerial/3.jpg`
  },
]
// generateGallery({ imagePath: 'images/residences-aerial', amount: 2, categoryId: 2 });

// const residencesExteriorData = generateGallery({ imagePath: 'images/residences-exterior', amount: 8, categoryId: 3 });
const residencesExteriorData = [
  {
    categoryId: 3,
    name: "Exterior - 1",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/1.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 2",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/2.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 3",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/3.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 4",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/4.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 5",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/5.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 6",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/6.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 7",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/7.jpg`
  },
  {
    categoryId: 3,
    name: "Exterior - 8",
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/gallery/images/residences-exterior/8.jpg`
  }
]
const residencesInteriorData = generateGallery({ imagePath: 'images/residences-interior', amount: 9, categoryId: 4 });
const residencesCommonAreaData = generateGallery({ imagePath: 'images/residences-common-area', amount: 10, categoryId: 5 });
const residencesLifestyleData = generateGallery({ imagePath: 'images/residences-lifestyle', amount: 8, categoryId: 6 });
const destinationLifestyleData = generateGallery({ imagePath: 'images/destination-lifestyle', amount: 16, categoryId: 7 });

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
  { image: heroShotImg5 },
  { image: heroShotImg6 },
  { image: heroShotImg7 },
  { image: heroShotImg8 },
];

const categories = [
  {
    id: 1,
    name: "All Images"
  },
  {
    id: 2,
    name: "Residences – Aerial"
  },
  {
    id: 3,
    name: "Residences – Exterior"
  },
  {
    id: 4,
    name: "Residences – Interior"
  },
  {
    id: 5,
    name: "Residences – Common Area"
  },
  {
    id: 6,
    name: "Residences – Lifestyle"
  },
  {
    id: 7,
    name: "Destination Lifestyle"
  }
];

const images = [
  ...residencesAerialData,
  ...residencesExteriorData,
  ...residencesInteriorData,
  ...residencesCommonAreaData,
  ...residencesLifestyleData,
  ...destinationLifestyleData,
];

const video = null;
const image360 = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/Dusit-Aerial/Dusit-Aerial2018.html`;

export default {
  heroShot,
  categories,
  images: _.map(images, image => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId })
    };
  }),
  video,
  image360,
  view360: [
    {
      id: 'aerial',
      src: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/Dusit-Aerial/Dusit-Aerial2018.html`
    },
    {
      id: 'interior',
      src: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/interior/DS-Living.html`
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/gallery.js